<template>
  <div>
    <span>{{ value }}</span>
  </div>
</template>

<script>
import moment from 'moment';
import BaseControlMixin from '@/components/controls/mixins/BaseControl';

const formats = {
  'L': 'L',
  'LL': 'LL',
  'LLL': 'LLL',
};

export default {
  name: 'DateDisplayField',
  mixins: [
    BaseControlMixin,
  ],
  computed: {
    value() {
      if (this.getSingleVar.value) {
        const format = formats[this.getSingleVar.format] || 'LL';
        return moment.utc(this.getSingleVar.value).format(format);
      }
      return this.$t('not-available');
    },
  },
};
</script>

<style scoped>

</style>
